module.exports = __webpack_public_path__ + "static/media/gypse.45eec685.png";